export default defineNuxtPlugin((nuxtApp) => {
  // Only run on client-side
  if (import.meta.client) {

    const allowedPages = [
      '/p/',
      '/success'
    ]

    const injectScript = () => {
      try {
        if (!document.getElementById('sizekick-script')) {
          const script = document.createElement('script')
          script.id = 'sizekick-script'
          script.src = 'https://widget.sizekick.io/goldner.js'
          script.type = 'module'
          script.async = true
          document.head.appendChild(script)
        }
      } catch (e) {
        console.error('Failed to initialize Sizekick widget', e)
      }
    }

    const removeScript = () => {
      try {
        const script = document.getElementById('sizekick-script')
        if (script) {
          script.remove()
        }
      } catch (e) {
        console.error('Failed to remove Sizekick script', e)
      }
    }

    // Check on page finish
    nuxtApp.hook('page:finish', () => {
      const route = useRoute()
      const isAllowedPage = allowedPages.some(path => route.path.includes(path))
      if (isAllowedPage) {
        injectScript()
      } else {
        removeScript()
      }
    })
  }
})